const dataCriterion = {
  dataInstructionsFollowed: {
    id: 'dataInstructionsFollowed',
    name: 'Instructions followed',
    data: {
      plagiarism_free: {
        id: 'plagiarism_free',
        name: 'Plagiarism free',
        tooltip: 'The information that is not common knowledge is cited. Original writing is minimum 70%. Direct quotes do not exceed 10% of the required word count.',
        grade: [0.0001, 0.00012, 0.00013, 0.00014, 0],
        grade_view: [0, 0, 0, 0, 0],
      },
      content: {
        id: 'content',
        name: 'Content',
        tooltip: 'The paper meets the Client’s requirements and does not contain any irrelevant or generic content.',
        grade: [1.5, 1.2, 1.05, 0.9, 0],
        grade_view: [1.5, 1.2, 1.05, 0.9, 0],
      },
      sources: {
        id: 'sources',
        name: 'Sources',
        tooltip: 'The required by the Client, relevant (published within the last 5-7 years) and reliable sources are properly incorporated.',
        grade: [1, 0.8, 0.7, 0.6, 0],
        grade_view: [1, 0.8, 0.7, 0.6, 0],
      },
      word_count: {
        id: 'word_count',
        name: 'Word count',
        tooltip: 'It is counted from the introduction to conclusion. Title and reference pages, as well as footnotes are excluded.',
        grade: [0.5, 0.4, 0.35, 0.3, 0],
        grade_view: [0.5, 0.4, 0.35, 0.3, 0],
      },
    }
  },
  dataLanguageAndFormat: {
    name: 'Language and format',
    id: 'dataLanguageAndFormat',
    data: {
      structure: {
        id: 'structure',
        name: 'Structure',
        tooltip: 'Thesis statement serves as a roadmap of the paper. Each paragraph is devoted to one idea. The paper is coherent and cohesive.',
        grade: [0.5, 0.4, 0.35, 0.3, 0],
        grade_view: [0.5, 0.4, 0.35, 0.3, 0],
      },
      language: {
        id: 'language',
        name: 'Language',
        tooltip: 'Sentence structure and word choice are correct. No proofreading issues.',
        grade: [1, 0.8, 0.7, 0.6, 0],
        grade_view: [1, 0.8, 0.7, 0.6, 0],
      },
      format: {
        id: 'format',
        name: 'Format',
        tooltip: 'Adherence to one required Format.',
        grade: [0.5, 0.4, 0.35, 0.3, 0],
        grade_view: [0.5, 0.4, 0.35, 0.3, 0],
      },
    },
  },
};

const dataCriterionCorrectAnswer = {
  correct_answers: {
    name: 'Сorrect answers',
    id: 'correct_answers',
    data: {
      correct_answers: {
        id: 'correct_answers',
        name: 'Correct Answers',
        grade: [5, 4, 3, 2, 0],
        grade_view: [5, 4, 3, 2, 0],
      },
    },
  },
};

const notNullCriterion = [
  'dataInstructionsFollowed',
];

export {
  dataCriterion,
  notNullCriterion,
  dataCriterionCorrectAnswer,
};



// WEBPACK FOOTER //
// ./src/constants/dataQACategoryNew.js